import React from "react";
import TitlePages from "../../../../layout/TitlePages";
import Breadcrumbs from "../../../../layout/Breadcrumbs";
import { convenios2023 } from "../../../../data/Convenios/dataConvenios"; // Importa solo los convenios de 2023

const Convenios2023 = () => {
  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[
            { label: "Transparencia", url: "/Convenios" },
            { label: "Convenios", url: "/Convenios" },
            { label: "2023" },
          ]}
        />

        <TitlePages title="Transparencia" subTitle="Convenios 2023" />

        <div className="w-100 mt-3 Content__grid">
          {convenios2023.map((plan) => (
            <div key={plan.id} className="margin-bottom-1">
              <a href={plan.url} target="_blank" rel="noopener noreferrer">
                <img
                  className="img-fluid hover-effect"
                  src={plan.image}
                  alt={"Convenios " + plan.title}
                />
              </a>
              <p className="mt-2">{plan.title.toUpperCase()}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Convenios2023;